import { render } from "./GroupPost.vue?vue&type=template&id=13f4bf20"
import script from "./GroupPost.vue?vue&type=script&lang=js"
export * from "./GroupPost.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__